
<template>
  <div id="dashboard">

    <vs-popup :title="listTitle" :active.sync="popupList">

      <vs-list>
        <vs-list-item :key="index" :title="ontime.nama" :subtitle="`absen - ${ontime.jam_absen}. lokasi - ${ontime.lokasi}`" v-for="(ontime, index) in listPilih">
          <template slot="avatar">
            <vs-avatar class="mx-5" :src="getImage('/profil/'+ontime.avatar)" size="45px"></vs-avatar>
          </template>
        </vs-list-item>
      </vs-list>
    </vs-popup>

    <div class="vx-row">

      <div class="vx-col lg:w-1/3 lg:mt-0 mt-base">
          <vx-card title="Persentase Kehadiran">

              <div slot="no-body" id="persentase">
                  <vue-apex-charts class="pb-6" type="donut" height="260" :options="Persentase.chartOptions" :series="persenSeries" />
              </div>

              <div class="flex justify-center">
                <flat-pickr v-model="persentaseTanggal" name="persentaseTanggal" v-validate="'required'" class="text-center mr-4" placeholder="Hari ini"/>
                <vs-button color="primary" @click="persentaseDonut(persentaseTanggal)">Go</vs-button>
              </div>

              <div class="flex justify-center mt-2">
                <vs-button size="small" class="mr-3" color="success" @click="pilihList(persentaseTanggal, 'Ontime', 'ontime')">Ontime</vs-button>
                <vs-button size="small" class="mr-3" color="warning" @click="pilihList(persentaseTanggal, 'Lambat', 'lambat')">Terlambat</vs-button>
                <vs-button size="small" color="danger" @click="pilihList(persentaseTanggal, 'Tidak Masuk', 'tidak')">Tidak Masuk</vs-button>
              </div>
          </vx-card>
      </div>
      
      <div class="vx-col w-full lg:w-1/3 sm:w-1/3 mb-base">
          <vx-card class="overlay-card overflow-hidden">
              <template slot="no-body">
                  <img src="@/assets/images/background/gedung-utama.jpg" alt="Gedung-Utama" class="responsive blur-1">
                  <div class="card-overlay text-white">
                      <div class="flex flex-col justify-between h-full">
                          <div class="text-center mt-8 w-full">
                              <h3 class="text-white mb-2 tracking-wide">Off Location</h3>
                              <p class="mb-6">PIP Makassar</p>
                              
                              <div class="flex justify-around w-full">
                                  <feather-icon icon="RadioIcon" svgClasses="w-24 h-24 text-white" />
                              </div>
                              
                              <div class="flex justify-around w-full">
                                  <h2 class="text-white text-big"> {{absenwfhs.length + absenkegiatans.length}}</h2>
                              </div>
                              
                          </div>
                          <div class="text-center w-full">
                              <div class="flex justify-between px-8 mb-8 text-xl">
                                  <span>WFH</span>
                                  <span>{{absenwfhs.length}}</span>
                              </div>
                              <div class="flex justify-between px-8 mt-8 text-xl">
                                  <span>Dinas Luar</span>
                                  <span>{{absenkegiatans.length}}</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </template>
          </vx-card>
      </div>
      
      <div class="vx-col w-full lg:w-1/3 sm:w-1/3 mb-base">
          <vx-card title="Tepat Waktu">
              <template slot="actions">
                  <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
              </template>

              <!-- CHART -->
              <template slot="no-body" id="pencapaian-kehadiran">
                  <div class="mt-2">
                      <vue-apex-charts type="radialBar" height="240" :options="analyticsData.goalOverviewRadialBar.chartOptions" :series="[kehadiranAtr.persen]"/>
                  </div>
              </template>

              <!-- DATA -->
              <div class="flex justify-between text-center mt-6" slot="no-body">
                  
                  <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                    <div class="px-2 mt-4">
                      <flat-pickr v-model="pencapaianTanggal" name="pencapaianTanggal" v-validate="'required'" class="w-full text-center"/>
                    </div>
                    <vs-button color="primary" type="flat" @click="popupActivo=true">Ontime</vs-button>
                    <p class="mb-4 text-3xl font-semibold">
                      {{ kehadiranAtr.ontime }}
                    </p>
                    
                  </div>
                  
                  <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">

                    <div class="px-2 mt-4">
                      <vs-button @click="pencapaianSubmit(pencapaianTanggal)" :disabled="!isPencapaianTanggal" class="w-full px-2 mb-0">Submit</vs-button>
                    </div>

                      <p class="mt-4">Jumlah Pegawai</p>
                      <p class="mb-4 text-3xl font-semibold">{{ kehadiranAtr.pegawai }}</p>
                      
                  </div>
              </div>
          </vx-card>
      </div>
    </div>
    
    <div class="vx-row">

        <div class="vx-col w-full mb-base">
            <vx-card title="Statistik Bulan Ini">
                <template slot="actions">
                    <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </template>
                <div slot="no-body" class="p-6 pb-0">
                    <vue-apex-charts
                      type="line"
                      height="266"
                      :options="Statistik.chartOptions"
                      :series="tanggalData" />
                </div>
            </vx-card>
        </div>
    </div>

  </div>
</template>

<script>

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Dashboard from '@/stores/dashboard/dashboard.js'
import VueApexCharts from 'vue-apexcharts'
import analyticsData from './analyticsData.js'
import moment from 'moment'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default {
  data () {
    return {
      analyticsData,
      pencapaianTanggal: moment().format("YYYY-MM-DD"),
      persentaseTanggal: moment().format("YYYY-MM-DD"),
      Statistik: {
        chartOptions: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 5,
              left: 0,
              blur: 4,
              opacity: 0.10
            }
          },
          grid: {
            borderColor: '#e7e7e7'
          },
          legend: {
            show: false
          },
          colors: ['#28c76f', '#ffb570', '#ea5455'],
          markers: {
            size: 2,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              style: {
                cssClass: 'text-grey fill-current'
              }
            },
            axisTicks: {
              show: false
            },
            categories: this.$store.state.dashboard.tanggalTanggal,
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: 'text-grey fill-current'
              },
              formatter (val) {
                return val > 999 ? `${(val / 1000).toFixed(1)}k` : val
              }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      Persentase: {
        comparedResult: [2, -3, 8],
        //series: this.$store.state.dashboard.persenSeries,
        chartOptions: {
          labels: ['Tepat waktu', 'Terlambat', 'Tidak masuk'],
          dataLabels: {
            enabled: true
          },
          legend: { show: false },
          chart: {
            offsetY: 30,
            type: 'donut',
            toolbar: {
              show: false
            }
          },
          stroke: { width: 0 },
          colors: ['#28c76f', '#FF9F43', '#EA5455'],
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#2dc49a', '#FFC085', '#f29292']
            }
          }
        }
      },
      listPilih: [],
      listTitle: null,
      titOntime: 'Ontime',
      titLambat: 'Lambat',
      titTidak: 'Tidak Masuk',
      popupList: false,
    }
  },
  components: {
    StatisticsCardLine,
    VueApexCharts,
    flatPickr
  },
  computed: {
    isPencapaianTanggal () {
      return this.pencapaianTanggal !== ''
    },
    absenwfhs () {
      return this.$store.state.dashboard.absenwfhs
    },
    absenkegiatans () {
      return this.$store.state.dashboard.absenkegiatans
    },
    kehadiranAtr () {
      return this.$store.state.dashboard.analisisKehadiranAtr
    },
    tanggalTanggal () {
      return this.$store.state.dashboard.tanggalTanggal
    },
    tanggalData () {
      return this.$store.state.dashboard.tanggalData
    },
    persenSeries () {
      return this.$store.state.dashboard.persenSeries
    },
  },
  created () {
    if (!Dashboard.isRegistered) {
      this.$store.registerModule('dashboard', Dashboard)
      Dashboard.isRegistered = true
    }
    //this.$store.dispatch('dashboard/fetchAbsenumum')
    this.$store.dispatch('dashboard/fetchAbsenwfh')
    this.$store.dispatch('dashboard/fetchAbsenkegiatan')
    this.$store.dispatch('dashboard/fetchAnalisisKehadiran', this.pencapaianTanggal)
    this.$store.dispatch('dashboard/fetchAnalisisTanggal', this.pencapaianTanggal)
    this.$store.dispatch('dashboard/fetchAnalisisPresentase', this.persentaseTanggal)
  }, 
  methods: {

    pencapaianSubmit(tanggal) {
      this.kehadiranAtr = []
      this.pencapaianTanggal = tanggal
      this.$store.dispatch('dashboard/fetchAnalisisKehadiran', tanggal)
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#pencapaian-kehadiran',
        scale: 0.45
      })
      setTimeout(() => {
        this.$vs.loading.close('#pencapaian-kehadiran > .con-vs-loading')
        this.kehadiranAtr = this.$store.state.dashboard.analisisKehadiranAtr
      }, 3000)
    },

    persentaseDonut(tanggal) {
      this.pesenListTepat = []
      this.pesenListTidak = []
      this.pesenListLambat = []
      this.persentaseTanggal = tanggal
      this.$store.dispatch('dashboard/fetchAnalisisPresentase', tanggal)
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#persentase',
        scale: 0.45
      })
      setTimeout(() => {
        this.$vs.loading.close('#persentase > .con-vs-loading')
        this.pesenListTepat = this.$store.state.dashboard.pesenListTepat
        this.pesenListLambat = this.$store.state.dashboard.pesenListLambat
        this.pesenListTidak = this.$store.state.dashboard.pesenListTidak
        this.persenSeries = this.$store.state.dashboard.persenSeries
      }, 3000)
    },

    pilihList(tanggal, title, sett) {
      this.listPilih = []
      this.listTitle = title
      let pilihAtr = {
        tanggal : tanggal,
        listset : sett
      }
      this.$store.dispatch('dashboard/fetchList', pilihAtr)
      this.$vs.loading()
      setTimeout(() => {
        this.$vs.loading.close()
        this.popupList = true
        this.listPilih = this.$store.state.dashboard.listPegawaiPresentase
      }, 5000)
    },

  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
/*! rtl:begin:ignore */
#dashboard {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
